import {
    WORKORDER,
    WORKORDER_SUCCESS,
    WORKORDER_ERROR,
    ADD_WORKORDER,
    ADD_WORKORDER_SUCCESS,
    ADD_WORKORDER_ERROR,
    UPDATE_WORKORDER,
    UPDATE_WORKORDER_SUCCESS,
    UPDATE_WORKORDER_ERROR,
    DELETE_WORKORDER,
    DELETE_WORKORDER_ERROR,
    DELETE_WORKORDER_SUCCESS,
    CLOSE_WORKORDER,
    CLOSE_WORKORDER_SUCCESS,
    CLOSE_WORKORDER_ERROR
} from "../constants/workOrderConstants";

const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: '',
    workOrderData:[]
};

function workOrderReducer(state = initialState, action) {
    switch (action.type) {
        case WORKORDER:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': ''
            });
        case WORKORDER_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case WORKORDER_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'workOrderData': action.data
            });
        case ADD_WORKORDER:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': ''
            });
        case ADD_WORKORDER_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case ADD_WORKORDER_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'workOrderData': [...state.workOrderData, action.data]
            });
        case UPDATE_WORKORDER:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': ''
            });
        case UPDATE_WORKORDER_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case UPDATE_WORKORDER_SUCCESS:
            const oldWorkOrderData = state.workOrderData ? state.workOrderData : []
            let newWorkOrderData
            if (typeof (oldWorkOrderData) === 'object' && oldWorkOrderData.lenght > 0) {
                newWorkOrderData = oldWorkOrderData.map(workOrder => { if (workOrder._id === action.data._id) { return action.data } else { return workOrder } })
            }


            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'workOrderData': newWorkOrderData
            });
        case DELETE_WORKORDER:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': ''
            });
        case DELETE_WORKORDER_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case DELETE_WORKORDER_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'workOrderData': state.workOrderData.filter(workOrder => workOrder._id !== action.data)

            });
        case CLOSE_WORKORDER:
            return Object.assign({}, state,
                {
                    'success': false,
                    'error': ''
                });
        case CLOSE_WORKORDER_ERROR:
            return Object.assign({}, state,
                {
                    'success': false,
                    'error': action
                });
        case CLOSE_WORKORDER_SUCCESS:

            return Object.assign({}, state,
                {
                    'success': false,
                    'error': '',
                    'workOrderData': action.data
                });
        default:
            return state;
    }
}

export default workOrderReducer